import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthGuard } from './guards/auth.guard';
import { AutoLoginGuard } from './guards/auto-login.guard';
import { LoggedInGuard } from './guards/logged-in.guard';

const routes: Routes = [
  environment.production ? {
    path: 'ui-elements',
    redirectTo: '/dashboard',
  } : {
    path: 'ui-elements',
    loadChildren: () => import('./pages/ui-elements/ui-elements.module').then( m => m.UiElementsPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule),
    canLoad: [LoggedInGuard, AutoLoginGuard],
    title: 'Login'
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./pages/forgot-password/forgot-password.module').then( m => m.ForgotPasswordPageModule),
    canLoad: [LoggedInGuard],
    title: 'Forgot Password'
  },
  {
    path: 'new-password/:token',
    loadChildren: () => import('./pages/new-password/new-password.module').then( m => m.NewPasswordPageModule),
    canLoad: [LoggedInGuard],
    title: 'New Password'
  },
  {
    path: 'landing',
    loadChildren: () => import('./pages/landing/landing.module').then( m => m.LandingPageModule),
    canLoad: [AuthGuard],
    title: 'Landing Page'
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./pages/dashboard/dashboard.module').then( m => m.DashboardPageModule),
    canLoad: [AuthGuard],
    title: 'My Portfolio'
  },
  {
    path: 'change-requests-history',
    loadChildren: () => import('./pages/change-requests-history/change-requests-history.module').then( m => m.ChangeRequestsHistoryPageModule),
    canLoad: [AuthGuard],
    title: 'Change Request History'
  },
  {
    path: 'fund-information',
    loadChildren: () => import('./pages/fund-information/fund-information.module').then( m => m.FundInformationPageModule),
    canLoad: [AuthGuard],
    title: 'Fund Information'
  },
  {
    path: 'documents',
    loadChildren: () => import('./pages/documents/documents.module').then( m => m.DocumentsPageModule),
    canLoad: [AuthGuard],
    title: 'Documents'
  },
  {
    path: 'profile',
    loadChildren: () => import('./profile/profile.module').then( m => m.ProfilePageModule),
    canLoad: [AuthGuard],
    title: 'Profile'
  },
  {
    path: 'tools',
    loadChildren: () => import('./pages/tools/tools.module').then( m => m.ToolsPageModule),
    canLoad: [AuthGuard],
    title: 'Tools'
  },
  {
    path: 'support-and-faq',
    loadChildren: () => import('./pages/support-and-faq/support-and-faq.module').then( m => m.SupportAndFaqPageModule),
    canLoad: [AuthGuard],
    title: 'Support and FAQ'
  },
  {
    path: 'privacy-center',
    loadChildren: () => import('./pages/privacy-centre/privacy-centre.module').then( m => m.PrivacyCentrePageModule),
    canLoad: [AuthGuard],
    title: 'Privacy Centre'
  },
  {
    path: 'version',
    loadChildren: () => import('./pages/version/version.module').then( m => m.VersionPageModule),
    title: 'Version page'
  },
  {
    path: 'from-admin/:token',
    loadChildren: () => import('./pages/from-admin/from-admin.module').then( m => m.FromAdminPageModule),
  },
  {
    path: '',
    redirectTo: '/landing',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: '/landing',
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
